module.exports = __webpack_public_path__ + "static/media/user.c890bb01.svg";